export const LS_LOCALE_KEY = 'language'

export function getCurrentLocale() {
  const locale = localStorage.getItem(LS_LOCALE_KEY) ?? 'nb-NO'
  return locale
}
